import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#151E28",
  "fill-rule": "evenodd",
  d: "M9.72 4.25a.25.25 0 0 0-.236.17L9.04 5.75h5.918l-.443-1.33a.25.25 0 0 0-.237-.17H9.721Zm6.82 1.5-.6-1.803a1.75 1.75 0 0 0-1.66-1.197H9.72a1.75 1.75 0 0 0-1.66 1.197l-.6 1.803H3a.75.75 0 0 0 0 1.5h1.298l.767 11.5a3.75 3.75 0 0 0 3.742 3.5h6.386a3.75 3.75 0 0 0 3.742-3.5l.767-11.5H21a.75.75 0 0 0 0-1.5h-4.46Zm1.658 1.5H5.802l.76 11.4a2.25 2.25 0 0 0 2.245 2.1h6.386a2.25 2.25 0 0 0 2.245-2.1l.76-11.4ZM10 9.75a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Zm4.75.75a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }